import { render, staticRenderFns } from "./customerAudit.vue?vue&type=template&id=40c37296&scoped=true&"
import script from "./customerAudit.vue?vue&type=script&lang=js&"
export * from "./customerAudit.vue?vue&type=script&lang=js&"
import style0 from "./customerAudit.vue?vue&type=style&index=0&id=40c37296&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c37296",
  null
  
)

export default component.exports